import moment from "moment";

export default class Helper {


    static safeJsonParse(jsonString, fallback = {}) {
        try {
            return JSON.parse(jsonString);
        } catch (error) {
            return fallback;
        }
    }
    
    static convertMonthDayToFullDate = (monthDayStr, extraYear = 0) => {

        let currentYear = moment().year();
        if (extraYear > 0) {
            currentYear = moment().year() + extraYear;
        } else if (extraYear < 0) {
            currentYear = moment().year() - Math.abs(extraYear);
        }

        const [month, day] = monthDayStr.split('-');

        const date = moment(`${currentYear}-${month}-${day}`, 'YYYY-MM-DD');

        if (!date.isValid()) {
            return 'Invalid date';
        }
        return date.format('YYYY-MM-DD');
    }
}